exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Xexf2g85mvKAWXrpa07KW label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._2-oentzkj2gk92Wx-ISpPu{display:flex;flex-flow:column nowrap}._2-oentzkj2gk92Wx-ISpPu>:first-child{margin-bottom:15px}\n", ""]);

// Exports
exports.locals = {
	"group": "_2Xexf2g85mvKAWXrpa07KW",
	"buttons": "_2-oentzkj2gk92Wx-ISpPu"
};